/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {

  document.addEventListener("DOMContentLoaded", function () {

    const filterBtn = document.querySelector("[data-toggle-filters]");
    const filters = document.querySelector(".collection__filters");
    const filter = document.querySelector(".collection__filters__toggle");

    if (filterBtn && filters && filter) {
      filterBtn.addEventListener("click", function () {
        filters.classList.toggle("active");
        filter.classList.toggle("active");
      });
    }

  });


  const boundScrollers = new WeakSet();


  function initScrollProgressBar(scroller, bar) {

    if (!scroller || !bar || boundScrollers.has(scroller)) {
      return;
    }

    const updateProgress = () => {

      const maxScroll =
        scroller.scrollWidth - scroller.clientWidth;

      const progress =
        maxScroll > 0
          ? scroller.scrollLeft / maxScroll
          : 0;

      bar.style.width =
        `${Math.max(0, Math.min(1, progress)) * 100}%`;
    };


    scroller.addEventListener(
      'scroll',
      updateProgress,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateProgress
    );

    updateProgress();

    boundScrollers.add(scroller);
  }


  function bindAllProgressBars() {

    document
      .querySelectorAll('.carousel--mobile')
      .forEach((scroller) => {

        const wrapper = scroller.parentNode;

        const bar = wrapper
          ? wrapper.querySelector('[data-slider-progress-bar]')
          : null;

        initScrollProgressBar(scroller, bar);

      });
  }


  /*
   * Initial bind
   */
  document.addEventListener(
    'DOMContentLoaded',
    bindAllProgressBars
  );


  /*
   * Watch for dynamically added/re-rendered sliders
   */
  const observer = new MutationObserver(() => {
    bindAllProgressBars();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * Existing theme events
   */
  document.addEventListener(
    'theme:tab:change',
    bindAllProgressBars
  );

  document.addEventListener(
    'theme:slider:resize',
    bindAllProgressBars
  );

})();



(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
